import { useMemo } from 'react';
import { findFarmOptionById, getUserFarmOptions } from 'farmContext';
import { useUserOrganisations } from 'hooks/useOrganisations';
import type { AccountInfoData } from 'types';
import { getOrganisationFarmOptions } from 'utils/organisationContext';
import { buildFarmPickerOptions } from 'utils/farmPickerOptions';

export const useFarmPickerCatalog = (accountInfo?: AccountInfoData) => {
  const { data: organisations, isLoading: isLoadingOrganisations } = useUserOrganisations();
  const farmOptions = useMemo(() => {
    const base = getUserFarmOptions(accountInfo);
    const fromOrganisations = getOrganisationFarmOptions(organisations);

    fromOrganisations.forEach((orgFarm) => {
      if (!findFarmOptionById(base, orgFarm.farmId)) {
        base.push(orgFarm);
      }
    });

    return base.sort((left, right) => left.label.localeCompare(right.label, 'sv', { sensitivity: 'base' }));
  }, [accountInfo, organisations]);
  const pickerOptions = useMemo(
    () => buildFarmPickerOptions(farmOptions, organisations, accountInfo),
    [accountInfo, farmOptions, organisations],
  );

  return {
    farmOptions,
    pickerOptions,
    organisations,
    isLoadingOrganisations,
  };
};
